import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import dynamic from "next/dynamic";
import { composeDataMethods } from "@lululemon/mwa-utils";
var HydrationOverlay = dynamic(function() {
    return import("@builder.io/react-hydration-overlay").then(function(mod) {
        return mod.HydrationOverlay;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("@builder.io/react-hydration-overlay")
            ];
        }
    }
});
export var withHydrationOverlay = function(Component) {
    if ("production" === "development") {
        var WithHydrationOverlay = function() {
            var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return /*#__PURE__*/ _jsx(HydrationOverlay, {
                children: /*#__PURE__*/ _jsx(Component, _object_spread({}, props))
            });
        };
        return composeDataMethods(Component, {})(WithHydrationOverlay);
    }
    return Component;
};
